import * as React from "react";
import PropTypes from "prop-types";
const SvgActivityElevationNormalXsmall = React.forwardRef(
  ({ color = "currentColor", size = 16, title, titleId, ...props }, ref) => (
    <svg
      fill={color}
      viewBox="0 0 16 16"
      xmlns="http://www.w3.org/2000/svg"
      ref={ref}
      width={size}
      height={size}
      aria-labelledby={titleId}
      {...props}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <path
        d="M4.493 3.028a1.125 1.125 0 011.99.042l2.054 4.106.97-1.697a1.125 1.125 0 011.97.032l3.124 5.898c.18.34.274.718.274 1.102a1.49 1.49 0 01-1.49 1.49H2.626A1.625 1.625 0 011 12.374v-2.358c0-.445.113-.882.328-1.271zm.979.814L2.422 9.35a1.375 1.375 0 00-.172.666v2.358c0 .207.168.375.375.375h10.76a.24.24 0 00.24-.24c0-.18-.044-.357-.128-.516l-3.018-5.698-2.016 3.528z"
        fill=""
      />
    </svg>
  )
);
SvgActivityElevationNormalXsmall.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  title: PropTypes.string,
  titleId: PropTypes.string,
};
export default SvgActivityElevationNormalXsmall;
